import {Document}					from '../../redux/documents/interface';
import {User}						from '../../redux/user/interface';

export function ft_getDocumentCreator(file: Document, users: User[]) {
	if (file.isValala)
		return 'Valala';

	const findCreator = users.find(find => find?._id === file?.data?.creator);

	return findCreator ? `${findCreator.firstname} ${findCreator.lastname}` : '?';
}